"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const PendingIcon = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.504 16.733a8.14 8.14 0 1 0 0-16.28 8.14 8.14 0 0 0 0 16.28"
      fill={Core.icon.warning}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M5.748 8.094 11.26 8.094"
    />
  </>,
  "PendingIcon",
  {
    viewBox: "0 0 17 17",
    titleAccess: "PendingIcon",
    color: "white",
  }
);
